import * as angular from "angular";
import {IController, IQService, ITimeoutService} from "angular";
import * as _ from "lodash";
import {AccountModel} from "../../../account/angular/models/account.model";
import {PredefinedSkillType} from "../../../skills/types/predefined-skill.type";
import {AddressesService} from "../../../addresses/services/addresses-service.factory";
import {SplitService} from "../../../commons/services/split-service.service";
import {BringozLoaderService} from "../../../commons/services/bringoz-loader.service";
import {OrdersDialogService} from "../../services/order-dialogs-service.service";
import {OrderRequestsService} from "../../services/order-requests.service";
import {OrdersService} from "../../services/orders-service.service";
import {DeliveriesAlertsService} from "../../../deliveries/services/deliveries-alerts.service";
import {DeliveriesService} from "../../../deliveries/services/deliveries-service.service";
import {CommonsAlertsService} from "../../../commons/services/commons-alerts.service";
import {ConfirmChangeStateService} from "../../../commons/services/confirm-change-state.service";
import {SiteContextService} from "../../../commons/services/site-context.service";
import {PackageConfigurationService} from "../../../site-preferences/services/package-configuration-service.service";
import {TaskModel} from "../../../tasks/models/task.model";
import {TaskPurposeType} from "../../../commons/types/task-purpose.type";
import {DepotModel} from "../../../depots/angular/models/depot.model";
import {ServicesViewsStateType} from "../../../deliveries/types/services-views-state.type";
import {ViewSettingsHolderType, ViewSettingsModel, ViewSettingsType} from "../../../commons/models/view-settings.model";
import {ViewSettingsService} from "../../../commons/services/view-settings-service.service";
import {LocationType} from "../../../commons/types/location.type";

export class createDeliveryCtrl implements IController {

  order: any;
  account: AccountModel;
  pricePlanBundle: any;
  defaultProgramType: any;
  defaultDepot: DepotModel;
  customers: any;
  isDuplicate: boolean;
  quote: any;

  public siteInfo: any;
  public isShouldSendSms: any;
  public excludedSkillsIds: any;

  private taskColorByPurpose: any;
  private selectedRelatedType: any;
  private vehicleTypes: any;
  private packageSizes: any;
  private identificationOptions: any;
  private customAddressEnabled: any;
  private addMarker: any;
  private collapse: any;
  private programHasChanged: boolean;
  private selectedDate: any;
  private skillOptions: any;
  private quotes: any;
  private addressZoneId: string;
  private configZoneId: string;
  private availableDays: any;
  private subTaskOptions: any;
  private selectedQuote: any;
  private defaultItemSize: any;
  public canCreateTag: boolean;
  public proxyProviderType: any;
  public callContactUsingProxyByDefaultValue: boolean;
  public isServiceExternalIdIsMandatory: boolean;
  public cashOnDeliveryActionTypesMap: any;
  public subTaskOptionsMap: any;
  public viewFormSettings: ViewSettingsModel;
  public locationTypes: typeof LocationType = LocationType;
  public useLegacyServiceTime: boolean;


  /* @ngInject */
  constructor(private $log, private $state, private orderRequestsService: OrderRequestsService, private ordersDialogService: OrdersDialogService, private ordersService: OrdersService,
              private deliveriesAlertsService: DeliveriesAlertsService, private commonsAlertsService: CommonsAlertsService, private siteContextService: SiteContextService, private packageConfigurationService: PackageConfigurationService,
              private tasksConstants, private deliveriesConstants, private $timeout: ITimeoutService, private $q: IQService, private moment, private viewSettingsService: ViewSettingsService,
              private confirmChangeStateService: ConfirmChangeStateService, private bringozLoaderService: BringozLoaderService, private addressesService: AddressesService, private splitService: SplitService,
              private deliveriesService: DeliveriesService, private IAMPermissions) {
  }

  $onInit() {
    this.cashOnDeliveryActionTypesMap = {
      Collect: true,
      Payment: true
    };

    this.useLegacyServiceTime = this.splitService.getUseLegacyServiceTime();

    this.siteInfo = this.siteContextService.getSiteInfo();
    this.proxyProviderType = this.siteInfo.proxyProviderType;
    this.callContactUsingProxyByDefaultValue = this.siteInfo.callContactUsingProxyByDefault;
    this.canCreateTag = this.IAMPermissions.hasPermission('infoTags.create');
    this.isShouldSendSms = true;
    this.configZoneId = this.splitService.getTimeZone();
    this.isServiceExternalIdIsMandatory = this.splitService.getIsServiceExternalIdIsMandatory();
    this.taskColorByPurpose = this.tasksConstants.typesToColor;
    this.selectedRelatedType = this.tasksConstants.relationTypes[0];
    this.vehicleTypes = [];
    this.packageSizes = [];
    this.identificationOptions = {
      Pickup: [],
      Dropoff: []
    };
    this.customAddressEnabled = {
      Pickup: false,
      Dropoff: false
    };
    this.addMarker = {
      purpose: undefined,
      taskIndex: undefined,
      enabled: false
    };
    this.programHasChanged = false;
    this.addressZoneId = undefined;

    // Sets the transition from this component as confirm prompt
    this.confirmChangeStateService.setIsEnabled(true);

    this.collapse = this.account.address && this.account.address.place && this.account.address.house && this.account.name && this.account.phoneNumber;

    this._loadOrderSettings(this.order.serviceList[0].pricePlanType);

    if (this.quotes) {
      const todayQuote = _.find(this.quotes, (q) => {
        return this.moment(q.startTime).isSame(this.moment(), 'day');
      })
      this._assignQuote(todayQuote || _.get(this.quotes, '[0]'));
    }

    if (this.isDuplicate) {
      var today = this.moment();
      var isBeforeToday = this.order.serviceList[0].notBefore < today.valueOf();
      var from = isBeforeToday ? today.startOf('day').valueOf() : this.order.serviceList[0].notBefore;
      var to = isBeforeToday ? today.endOf('day').valueOf() : this.order.serviceList[0].notAfter;
      this._loadQuotes(this.order.serviceList[0].pricePlanType, from, to, true);
    }

    this._setUseProxyCallDefaultValue();
    this.excludedSkillsIds = [PredefinedSkillType.Delivery];
    this._initViewSettings();
  };

  // ******************************
  //        Public methods
  // ******************************

  onReferenceIdsChange(referenceIds) {
    this.order.serviceList[0].referenceIds = referenceIds;
  }

  onPackageChange(packageItem, index) {
    _.set(packageItem, 'size', packageItem.type);
    _.unset(packageItem, 'type');

    const itemsCopy = angular.copy(this.order.serviceList[0].packageList[0].items);

    itemsCopy[index] = packageItem;
    this.order.serviceList[0].packageList[0].items = itemsCopy;

  }

  swapTasks() {
    this.$log.debug('swapTasks');
    this.ordersService.swapTasks(this.order.serviceList[0]);
    this._swapPurposeRefs();
    this.setQuotesByDate(this.selectedDate);
  }

  onIdentificationsChange(identifications, taskRef) {
    taskRef.taskSpec.identifications = identifications
  }

  onPricePlanChange(pricePlan) {
    this.$log.debug('onPricePlanChange', pricePlan);
    this.programHasChanged = true;
    this._loadOrderSettings(pricePlan.type, true);
  }

  setQuotesByDate(date) {
    const from = this.moment(date).startOf('day').valueOf();
    const to = this.moment(date).endOf('day').valueOf();

    const taskWithoutAddress = _.find(this.order.serviceList[0].taskList, (task: TaskModel) => {
      return !_.get(task.taskSpec, 'address');
    });

    if (!taskWithoutAddress) {
      this._loadQuotes(this.order.serviceList[0].pricePlanType, from, to, true);
    } else {
      this.quotes = undefined;
      this.selectedQuote = undefined;
    }
  }

  onQuoteChange(quote) {
    this._assignQuote(quote);
  }

  onLocationButtonToggle(isEnabled, task, index) {
    this.addMarker = {
      purpose: task.taskSpec.purpose,
      taskIndex: index,
      enabled: isEnabled,
    };
  }

  onTaskLocationSelect(location) {
    const index = this.addMarker.taskIndex;
    this._setLatLng(location.lat, location.lng, index);
  }

  onToggleCustom(task: TaskModel) {
    const taskPurposeRef = task.taskSpec.purpose;
    this.customAddressEnabled[taskPurposeRef] = !this.customAddressEnabled[taskPurposeRef];
    if (this.addMarker.purpose === taskPurposeRef) {
      this.addMarker.enabled = false;
    }
  }

  onCustomerChange(customer, purpose) {
    // if (!this.isDuplicate) {
    this.customers[purpose] = customer;
    // }
    this.addMarker.enabled = false;
  }

  onAddressChange(address) {
    if (!_.isEmpty(address)) {
      const from = this.moment(this.selectedDate).startOf('day').valueOf();
      const to = this.moment(this.selectedDate).endOf('day').valueOf();

      this._loadQuotes(this.order.serviceList[0].pricePlanType, from, to, true);
    } else {
      this.quotes = undefined;
      this.selectedQuote = undefined;
    }
  }

  onRelationTypeChange(relationType) {
    this.selectedRelatedType = relationType;
  }

  onAddRelatedTask(relatedTask, task) {
    if (relatedTask) {
      if (!task.relations) {
        task.relations = [];
      }
      task.relations.push(
        {
          type: this.selectedRelatedType,
          relatedTaskId: relatedTask.id,
          details: {
            serviceType: relatedTask.serviceType,
            taskPurpose: relatedTask.taskSpec.purpose,
            serviceId: relatedTask.serviceId,
            serviceExternalId: relatedTask.serviceExternalId,
            accountId: relatedTask.account.id,
            accountName: relatedTask.account.name,
            agentId: _.get(relatedTask, 'agent.id'),
            agentFirstName: _.get(relatedTask, 'agent.user.firstName'),
            agentLastName: _.get(relatedTask, 'agent.user.lastName'),
            status: relatedTask.status
          }

        }
      );
      task.relations = _.uniqBy(task.relations, 'relatedTaskId')
    }
  }

  onRemoveRelatedTask(task, $index) {
    task.relations.splice($index, 1);
  }

  onAddSubTaskToTask(task, subtask) {
    if (subtask.actions?.length) {
      subtask.actions = this._getSubTaskActionsWithDefaults(subtask);
    }

    if (task) {
      if (!task.subTasks) {
        task.subTasks = [];
      }
      task.subTasks.unshift(angular.copy(subtask));
    }
  }

  onSubTasksChanged(task, subTasks) {
    if (task) {
      task.subTasks = subTasks;
    }
  }

  onRemoveSubtask(task, subtask, index) {
    if (task) {
      task.subTasks.splice(index, 1);
      if (!task.subTasks?.length) {
        task.subTasks = undefined;
      }
    }
  }

  onAddAttachment() {
    this.deliveriesService.addDeliveryAttachments()
      .then((attachment) => {
        if (!this.order.serviceList[0].attachments) {
          this.order.serviceList[0].attachments = [];
        }
        this.order.serviceList[0].attachments.push(attachment);
      })
  }

  onRemoveAttachment(index) {
    this.order.serviceList[0].attachments.splice(index, 1);
  }

  onTagsChange(tagNames) {
    this.order.serviceList[0].tagNames = tagNames;
  }

  _ConfirmOrder(event) {
    return this.orderRequestsService.getOrderPrice(this.order, this.order.accountId)
      .then((orderPrice) => { // Confirm Price
        this.order.serviceList[0].billing = orderPrice.serviceBillings[0];
        return this.ordersDialogService.confirmOrderSummary(event, orderPrice);
      })
      .then((paymentMethod) => { // Place Order
        this.order.pmid = paymentMethod;
        return this.$q.when();
      });
  }

  submit(form, event) {

    form.Pickup.$setSubmitted();
    form.Dropoff.$setSubmitted();

    if (form.$valid) {
      this.bringozLoaderService.on();
      this._ConfirmOrder(event)
        .then(() => {

          this._setDefaultTags();
          if (this.order.serviceList[0].packageList[0]?.items?.length) {
            this.order.serviceList[0].packed = true;
          }
          return this.orderRequestsService.placeOrder(this.order, this.order.accountId, this.isShouldSendSms);
        })
        .then((createdOrder) => {
          this.deliveriesAlertsService.createDeliverySuccess(createdOrder.serviceList[0], true)
            .then((res) => {
              if (res) {
                // Reset transition confirmation prompt
                this.confirmChangeStateService.reset();

                this.$state.go(this.deliveriesConstants.redirectLinkByTextTriggerGroup.Delivery, {
                  id: createdOrder.serviceIdList[0]
                });
              }
            });
          this.customers = {
            Pickup: undefined,
            Dropoff: undefined
          };

          const emptyOrder = angular.copy(this.order);
          emptyOrder.serviceList[0] = this.ordersService.getEmptyDeliveryService(this.account, this.defaultDepot, this.defaultProgramType, undefined, undefined);

          // if (_.get(this.account, 'defaultDepotId')) {
          //   emptyOrder.serviceList[0].taskList[0].taskSpec.depotReference = {
          //     id: this.account.defaultDepotId
          //   }
          // }

          this.order = emptyOrder;
          this._loadOrderSettings(this.order.serviceList[0].pricePlanType);

          form.$setPristine();
          form.$setUntouched();
        })
        .catch((error) => {
          if (error) {
            if (error.code === 400301) {
              this.deliveriesAlertsService.outOfServiceZoneError();
            } else if (error.code === 400306) {
              this.deliveriesAlertsService.invalidDeliveryDayError();
            } else {
              this.commonsAlertsService.somethingWentWrongError();
            }
            this.$log.error('createOrderFlowError', error);
          } else {
            this.$log.info('Dialog Closed');
          }
        })
        .finally(() => {
          this.bringozLoaderService.off();
        });
    } else {
      this.collapse = false;
      this.commonsAlertsService.formInvalidInfo();
    }
  }

  onSkillsChange(ids) {
    this.order.serviceList[0].requiredSkills = ids;
  }

  // ******************************
  //        Private methods
  // ******************************

  _loadOrderSettings(selectedPricePlanType, reloadQuotes?) {
    // const quoteTypes = ['Urgency','TimeSlot','DynamicTimeSlot','FreeStyle','PerTask'];

    this.ordersService.getOrderSettings(this.order.accountId, this.order.serviceList[0].serviceType, selectedPricePlanType)
      .then((orderSettings) => {

        const serviceRef = orderSettings;
        this.order.pricePlanType = selectedPricePlanType;
        this.order.serviceList[0].pricePlanType = selectedPricePlanType;
        this.availableDays = _.get(serviceRef, 'availableDays', []);

        this.order.serviceList[0].taskList[0].taskValidationList = undefined;
        this.order.serviceList[0].taskList[1].taskValidationList = undefined;
        orderSettings.enabledServiceValidations?.forEach((validation) => {

          if (validation.enabledTaskPurpose?.includes(TaskPurposeType.Pickup)) {
            if (!this.order.serviceList[0].taskList[0].taskValidationList) {
              this.order.serviceList[0].taskList[0].taskValidationList = []
            }
            this.order.serviceList[0].taskList[0].taskValidationList.push(validation);
          }

          if (validation.enabledTaskPurpose?.includes(TaskPurposeType.Dropoff)) {
            if (!this.order.serviceList[0].taskList[1].taskValidationList) {
              this.order.serviceList[0].taskList[1].taskValidationList = []
            }
            this.order.serviceList[0].taskList[1].taskValidationList.push(validation);
          }
        })

        const today = _.find(this.availableDays, (d) => {
          return this.moment().isSame(this.moment(d), 'day');
        })
        this.selectedDate = today || (this.availableDays.length ? this.moment(_.head(this.availableDays)).toDate() : undefined);
        this.skillOptions = _.uniq(_.get(serviceRef, 'enabledSkills', []).concat([PredefinedSkillType.Delivery]));
        this.vehicleTypes = _.get(serviceRef, 'vehicleList', []);

        this.subTaskOptionsMap = {
          [TaskPurposeType.Pickup]: [],
          [TaskPurposeType.Dropoff]: []
        }

        serviceRef.optionalSubTasks.forEach(optionalSubTask => {
          if (optionalSubTask.purposes.includes(TaskPurposeType.Pickup)) {
            this.subTaskOptionsMap.Pickup.push(optionalSubTask);
          }

          if (optionalSubTask.purposes.includes(TaskPurposeType.Dropoff)) {
            this.subTaskOptionsMap.Dropoff.push(optionalSubTask);
          }
        })
        this.packageSizes = _.get(serviceRef, 'itemSizeList', []);
        this.defaultItemSize = _.get(serviceRef, 'defaultItemSize');

        if (!this.order.serviceList[0].packageList[0].items) {
          this.order.serviceList[0].packageList[0].items = [];
        }

        if (!this.isDuplicate) {
          this.order.serviceList[0].vehicleType = _.get(serviceRef, 'defaultVehicle');
          this.order.serviceList[0].requiredSkills = _.get(orderSettings, 'defaultSkills', []);

          if (!this.order.serviceList[0].requiredSkills?.length) {
            this.order.serviceList[0].requiredSkills = [PredefinedSkillType.Delivery];
          }

          _.forEach(this.order.serviceList[0].taskList, (t) => {
            t.subTasks = [];
            serviceRef.defaultSubTasks.forEach(defaultSubTask => {
              if (defaultSubTask.purposes.includes(t.taskSpec.purpose)) {
                t.subTasks.push(defaultSubTask);
              }
            })

            t.subTasks?.forEach(st => {
              st.actions = this._getSubTaskActionsWithDefaults(st);
            })
          })

          if (!this.isDuplicate || !_.isLength(this.order.serviceList[0].packageList[0].items)) {
            const defaultItemSizeItem = _.find(this.packageSizes, (p) => {
              return p.itemSize === _.get(serviceRef, 'defaultItemSize');
            });
            if (defaultItemSizeItem) {
              this.order.serviceList[0].packageList[0].items = [
                {
                  count: 1,
                  barcode: null,
                  size: defaultItemSizeItem.itemSize || 'NoPackage',
                  labels: defaultItemSizeItem.labels || [],
                  dimensions: angular.copy(defaultItemSizeItem.dimensions) || {},
                  weight: defaultItemSizeItem.weight
                }
              ];
            }
          }
        }
        // } else {
        //   this.isDuplicate = false;
        // }


        this.identificationOptions = {
          Pickup: this.ordersService.buildIdentificationOptions(
            _.get(serviceRef, 'pickupPodSettings'),
            _.get(serviceRef, 'pickupPodFillRequiredSettings')
          ),
          Dropoff: this.ordersService.buildIdentificationOptions(
            _.get(serviceRef, 'dropoffPodSettings'),
            _.get(serviceRef, 'dropoffPodFillRequiredSettings')
          ),
        };


        // Set tasks default service time
        _.forEach(this.order.serviceList[0].taskList, (t) => {

          if (t.taskSpec.purpose === 'Pickup') {
            if (this.useLegacyServiceTime) {
              _.unset(t.taskSpec, 'detailedServiceTime');
              t.taskSpec.serviceTime = _.get(serviceRef, 'serviceTimeSettings.pickupDetailedServiceTime.generatedTotalTime', 0);
            } else {
              _.unset(t.taskSpec, 'serviceTime');
              t.taskSpec.detailedServiceTime = _.get(serviceRef, 'serviceTimeSettings.pickupDetailedServiceTime', {})
            }
          }

          if (t.taskSpec.purpose === 'Dropoff') {
            if (this.useLegacyServiceTime) {
              _.unset(t.taskSpec, 'detailedServiceTime');
              t.taskSpec.serviceTime = _.get(serviceRef, 'serviceTimeSettings.dropoffDetailedServiceTime.generatedTotalTime', 0);
            } else {
              _.unset(t.taskSpec, 'serviceTime');
              t.taskSpec.detailedServiceTime = _.get(serviceRef, 'serviceTimeSettings.dropoffDetailedServiceTime', {})
            }
          }
        });

        if (!this.isDuplicate) {
          this._setTasksDefaultIdentification(
            _.get(serviceRef, 'pickupPodSettings'),
            _.get(serviceRef, 'dropoffPodSettings'),
            _.get(serviceRef, 'pickupPodFillRequiredSettings'),
            _.get(serviceRef, 'dropoffPodFillRequiredSettings')
          );
        }

        if (reloadQuotes) {
          this.setQuotesByDate(this.selectedDate);
        }

      })
  }

  _loadQuotes(selectedPricePlanType, from?, to?, assignQuotes?) {
    if (this.order.serviceList[0].taskList[1].taskSpec?.address &&
      !!Object.keys(this.order.serviceList[0].taskList[1].taskSpec?.address).length) {
      const services = this._getServices(this.order);

      this.ordersService.getOrderQuote(services, this.order.accountId, selectedPricePlanType, from, to)
        .then((service) => {
          this.quotes = service.quotes;
          this.addressZoneId = _.get(service, 'destinationZoneId');

          if (assignQuotes) {
            const todayQuote = _.find(this.quotes, (q) => {
              return this.moment(q.startTime).isSame(this.moment(), 'day');
            });
            this._assignQuote(todayQuote || _.get(this.quotes, '[0]'));
          }
        })
    }
  }

  _setUseProxyCallDefaultValue() {
    if (this.proxyProviderType !== 'Default') {
      _.forEach(this.order.serviceList[0].taskList, task => {
        task.taskSpec.useProxyCall = this.callContactUsingProxyByDefaultValue;
      })
    }
  }

  _assignQuote(quote) {
    this.selectedQuote = angular.copy(quote);

    if (_.get(quote, 'type') === 'PerTask') {
      quote = this.quotes[0];
    }

    this.selectedDate = quote ?
      new Date(quote.type === 'PerTask' ? _.get(quote, 'quotes[0].startTime') : _.get(quote, 'startTime'))
      : undefined;

    this.deliveriesService.updateDeliveryQuote(this.order.serviceList[0], quote);
  }

  _setLatLng(lat, lng, taskIndex) {
    this.$timeout(0)
      .then(() => {
        this.order.serviceList[0].taskList[taskIndex].taskSpec.address.location = this.addressesService.getAddressLocation(lat, lng);
      });
  }

  _swapPurposeRefs() {
    const tmpCustomAddressPickupEnabled = this.customAddressEnabled.Pickup;
    this.customAddressEnabled.Pickup = this.customAddressEnabled.Dropoff;
    this.customAddressEnabled.Dropoff = tmpCustomAddressPickupEnabled;

    const customersCopy = angular.copy(this.customers);
    const tmpCustomersPickup = angular.copy(_.get(this.customers, 'Pickup'));
    customersCopy.Pickup = angular.copy(_.get(this.customers, 'Dropoff'));
    customersCopy.Dropoff = tmpCustomersPickup;
    this.customers = customersCopy;

    this.addMarker.purpose = this.addMarker.purpose ? (this.addMarker.purpose === 'Pickup' ? 'Dropoff' : 'Pickup') : undefined;
  }

  _getServices(order) {
    const services = [{
      serviceType: order.serviceList[0].serviceType,
      tasks: []
    }];
    order.serviceList[0].taskList.forEach((task: TaskModel) => {
      const taskObj: any = {
        purpose: task.taskSpec.purpose,
        address: task.taskSpec.address,
        serviceTimeInMillis: undefined
      }

      if (task.taskSpec?.locationDetails?.locationType === this.locationTypes.DEPOT && task.taskSpec?.locationDetails?.id) {
        taskObj.depotId = task.taskSpec.locationDetails.id
      }

      if (task.taskSpec?.locationDetails?.locationType === this.locationTypes.CUSTOMER && task.taskSpec?.locationDetails?.id) {
        taskObj.customerId = task.taskSpec.locationDetails.id
      }
      services[0].tasks.push(taskObj);
    });
    return services;
  }

  _setTasksDefaultIdentification(
    pickupPodSettings,
    dropoffPodSettings,
    pickupPodFillRequiredSettings,
    dropoffPodFillRequiredSettings
  ) {
    const defaultPickupIdentification = this.ordersService.buildDefaultIdentifications(
      pickupPodSettings,
      pickupPodFillRequiredSettings
    );
    const defaultDropoffIdentification = this.ordersService.buildDefaultIdentifications(
      dropoffPodSettings,
      dropoffPodFillRequiredSettings
    );

    _.forEach(this.order.serviceList[0].taskList, (t) => {
      const purpose = t.taskSpec.purpose;
      t.taskSpec.identifications = purpose === 'Pickup' ?
        defaultPickupIdentification :
        defaultDropoffIdentification;
    });
  }

  private _setDefaultTags() {
    if (this.isDuplicate) {
      if (!this.order.serviceList[0].tagNames) {
        this.order.serviceList[0].tagNames = ['duplicate']
      } else if (!this.order.serviceList[0].tagNames.includes('duplicate')) {
        this.order.serviceList[0].tagNames.push('duplicate');
      }

    }
  }

  private _getSubTaskActionsWithDefaults(subTask) {
    if (!subTask.actions?.length) return [];

    return subTask.actions.map((a) => {

      if (this.cashOnDeliveryActionTypesMap[a.type]) {

        a.paymentMethods = a.paymentMethods?.length ? a.paymentMethods : [{
          method: undefined,
          requestAmount: undefined,
          editable: true
        }];
      }
      return a;
    });
  }

  private _initViewSettings() {
    this.viewSettingsService.getBySite(ServicesViewsStateType.DELIVERIES_FORM_STATE, ViewSettingsType.Form)
      .then((viewSettings: ViewSettingsModel[]) => {
        const userViewFormSettings = viewSettings.find(v => v.holderType === ViewSettingsHolderType.Site);
        if (userViewFormSettings) {
          this.viewFormSettings = userViewFormSettings
        } else {
          this.viewFormSettings = viewSettings.find(v => v.holderType === ViewSettingsHolderType.Site);
        }
      })
  }

}

angular
  .module('bringoz.admin.orders')
  .component('createDelivery', {
    bindings: {
      order: '<',
      account: '<',
      pricePlanBundle: '<',
      defaultProgramType: '<',
      defaultDepot: '<',
      customers: '<?',
      isDuplicate: '<?',
      quotes: '<?'
    },
    template: require('./create-delivery.html').default,
    controller: createDeliveryCtrl
  });
